<template>
  <div v-html="highlight()"></div>
</template>

<script>
import { mapGetters } from "vuex";
import { highlightSubstring } from "@/utils/highlightSubstring";

export default {
  name: "UnpCell",
  props: ["value", "row", "column"],

  methods: {
    highlight() {
      return highlightSubstring(
        this.value,
        this.currentTab.searchCriteria.organizations,
      );
    },
  },

  computed: {
    ...mapGetters("filterTabs", ["currentTab"]),
  },
};
</script>

<style lang="less" scoped></style>
